import React from 'react';

export const Recurring = () => (
  <svg
    width="73"
    height="72"
    viewBox="0 0 73 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="72" height="72" rx="36" fill="#EFF6FF" />
    <path
      d="M47.9444 20H25.0559C22.5436 20 20.5 22.0103 20.5 24.4805V27.26H52.5V24.4805C52.5 22.0102 50.4565 20 47.9444 20ZM28.7634 25.1406C28.0491 25.1406 27.4706 24.5711 27.4706 23.8694C27.4706 23.1678 28.0491 22.5981 28.7634 22.5981C29.477 22.5981 30.0555 23.1678 30.0555 23.8694C30.0555 24.5711 29.477 25.1406 28.7634 25.1406ZM44.2367 25.1406C43.5229 25.1406 42.9446 24.5711 42.9446 23.8694C42.9446 23.1678 43.5229 22.5981 44.2367 22.5981C44.951 22.5981 45.5292 23.1678 45.5292 23.8694C45.5292 24.5711 44.951 25.1406 44.2367 25.1406ZM20.5 47.5196C20.5 49.9898 22.5436 52 25.0559 52H47.9444C50.4564 52 52.5 49.9897 52.5 47.5195V29.1881H20.5V47.5196ZM28.7856 43.3782L29.8614 39.3784C30.0148 38.8084 30.7383 38.615 31.1631 39.0308L34.1486 41.947C34.574 42.3623 34.3825 43.0749 33.804 43.2292L32.8055 43.4959C34.712 45.6536 37.2792 45.4963 37.3001 45.501C42.5688 45.501 45.2447 39.2149 41.5447 35.5237C39.1194 33.1057 35.0422 33.1584 33.0233 35.9499C32.7094 36.3836 32.0971 36.4851 31.656 36.1768C31.2147 35.8682 31.1115 35.2668 31.4252 34.8331C34.1452 31.0716 39.6523 30.8904 42.9407 34.1704C44.4406 35.6658 45.2502 37.6477 45.2209 39.7498C45.1608 43.9876 41.6087 47.4289 37.3001 47.4289C37.2797 47.4236 33.2509 47.6111 30.7631 44.0408L29.7424 44.3132C29.164 44.4675 28.6322 43.9482 28.7856 43.3782Z"
      fill="#3B82F6"
    />
    <path
      d="M23.0358 16.8004C22.5161 16.8132 22.0839 16.4023 22.0711 15.8826L22.0091 13.3729C21.9963 12.8533 22.408 12.4216 22.9277 12.4087C23.4471 12.3963 23.8782 12.8073 23.891 13.3268L23.953 15.8365C23.9656 16.3559 23.5552 16.7874 23.0358 16.8004ZM18.8019 18.4423C18.3429 18.6864 17.7725 18.5121 17.5283 18.0532L16.3491 15.8372C16.105 15.3783 16.2793 14.8078 16.7382 14.5636C17.1972 14.3194 17.7676 14.4938 18.0118 14.9527L19.191 17.1687C19.4352 17.6277 19.2608 18.1981 18.8019 18.4423ZM12.6775 22.0885C12.1683 21.9839 11.8406 21.4866 11.9451 20.9774C12.0498 20.4682 12.5471 20.1405 13.0563 20.245L15.5152 20.7499C16.0243 20.8545 16.352 21.3518 16.2475 21.861C16.1429 22.3702 15.6456 22.6979 15.1364 22.5934L12.6775 22.0885ZM12.7834 28.1821C12.2813 28.3167 11.7644 28.019 11.6298 27.5169C11.4952 27.0147 11.7937 26.4984 12.2958 26.3638L14.7207 25.714C15.2227 25.5796 15.7383 25.8775 15.873 26.3795C16.0075 26.8815 15.7102 27.3975 15.2083 27.5323L12.7834 28.1821Z"
      fill="#BFDBFE"
    />
    <rect
      width="18"
      height="19"
      transform="translate(27.5 31)"
      fill="#3B82F6"
    />
    <g clipPath="url(#clip0_24944_19070)">
      <path
        d="M37 43.0156C38.9416 43.0156 40.5156 41.4416 40.5156 39.5C40.5156 37.5584 38.9416 35.9844 37 35.9844C35.0584 35.9844 33.4844 37.5584 33.4844 39.5C33.4844 41.4416 35.0584 43.0156 37 43.0156Z"
        fill="white"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.522 35.0917C32.8108 33.4921 34.7859 32.5859 37 32.5859C40.8832 32.5859 43.9141 35.6168 43.9141 39.5C43.9141 40.128 43.8317 40.7368 43.6773 41.3162M42.478 43.9083C41.1892 45.5079 39.2141 46.4141 37 46.4141C33.1168 46.4141 30.0859 43.3832 30.0859 39.5C30.0859 38.893 30.1628 38.304 30.3075 37.7422M37 38.3281V39.5H38.1719"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1406 33.6406V35.3984H32.8984M41.1016 43.6602H42.8594V45.3594"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 38V40H38.5"
        stroke="#3B82F6"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_24944_19070">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(29.5 32)"
        />
      </clipPath>
    </defs>
  </svg>
);
